// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__24Aaj","filesListContainer":"PosDisputesFiles_filesListContainer__1UZzM","filesButton":"PosDisputesFiles_filesButton__2S21w"};